import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import CorrectAnswerIcon from '../../assets/icons/complete.svg';
import IncorrectAnswerIcon from '../../assets/icons/incorrect.svg';
export const SessionTaskAnswerDetailRaw = ({ value, isCorrect, }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "session-task-answer-details", children: [_jsxs("div", { className: "session-task-answer-value", children: [_jsx("div", { className: "session-task-answer-value-text", children: value }), _jsx("div", { className: "session-task-answer-value-valuation", children: isCorrect ? _jsx(CorrectAnswerIcon, {}) : _jsx(IncorrectAnswerIcon, {}) })] }), _jsx("div", { className: "session-task-answer-note", children: isCorrect ? t('admin.correct_answer') : t('admin.incorrect_answer') })] }));
};
export default SessionTaskAnswerDetailRaw;
